import React, { useState } from "react";
import { IconButton, Avatar } from "@mui/material";

import { StyledVehicleDetailHistory } from ".";
import arrow_increase from "@assets/Icons/arrow_increase.svg";
import arrow_decrease from "@assets/Icons/arrow_decrease.svg";
import { linkAvatar } from "@utils";
import default_avatar from "@assets/Images/default_avatar.jpg";
interface IProps {
  historyList?: any;
}
export const VehicleDetialHistoryComponent = (props: IProps) => {
  const { historyList } = props;
  const [viewMore, setViewMore] = useState<boolean>(false);
  return (
    <StyledVehicleDetailHistory>
      <div className="title" style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}><span>使用履歴</span><span style={{marginLeft: "1rem", fontSize:"1.25rem", backgroundColor: "#f5f5f5", border: "1px solid #ccc", padding: "0.25rem 0.5rem", borderRadius: "0.5rem", cursor: "pointer"}} onClick={() => setViewMore(!viewMore)}>{viewMore ? "閉じる" : "もっと見る"}</span></div>
      <div className="wrapper">
        {historyList &&
          historyList?.borrowings?.slice(0, viewMore ? 50 : 5).map((item, index) => {
            return (
              <div className="HistoryInventory" key={index}>
                <div className="wrapperImage">
                  <Avatar
                    className="image"
                    src={
                      item?.user?.avatar?.path
                        ? linkAvatar(item?.user?.avatar?.path)
                        : default_avatar
                    }
                  />
                </div>
                <div className="wrapperContent">
                  <p className="name">
                    {item?.user?.last_name}
                    {item?.user?.first_name}
                  </p>

                  <p className="subTitle">
                    <span className="amount">{item.from}~{item.to}</span>
                  </p>
                </div>
                <div className="button">
                  <div className="wrapperbtn">
                    <span className="amount">-{item.quantity}</span>
                    <span className="btn">
                      <IconButton disableRipple={true}>
                        <img src={arrow_decrease} alt="icon" />
                      </IconButton>
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        {historyList &&
          historyList?.return_items?.slice(0, viewMore ? 50 : 5).map((item, index) => {
            return (
              <div className="HistoryInventory" key={index}>
                <div className="wrapperImage">
                  <img
                    className="image"
                    src={
                      item?.user?.avatar?.path
                        ? linkAvatar(item?.user?.avatar?.path)
                        : default_avatar
                    }
                    alt="inventory history"
                  />
                </div>
                <div className="wrapperContent">
                  <p className="name">
                    {item?.user?.last_name}
                    {item?.user?.first_name}
                  </p>
                  <p className="subTitle">
                    <span className="amount">{item.from}~{item.to}</span>
                  </p>
                </div>
                <div className="button">
                  <div className="wrapperbtn">
                    <span className="amount">+{item.quantity}</span>
                    <span className="btn">
                      <IconButton disableRipple={true}>
                        <img src={arrow_increase} alt="icon" />
                      </IconButton>
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        {historyList &&
          historyList?.slice(0, viewMore ? 50 : 5).map((item, index) => {
            return (
              <div className="HistoryInventory" key={index}>
                <div className="wrapperImage">
                  <img
                    className="image"
                    src={
                      item?.user?.avatar?.path
                        ? linkAvatar(
                          //   "https://livelet-production.s3.ap-northeast-3.amazonaws.com/" +
                          item?.user?.avatar?.path
                        )
                        : default_avatar
                    }
                    alt="inventory history"
                  />
                </div>
                <div className="wrapperContent">
                  <p className="name">
                    {item?.user?.last_name}
                    {item?.user?.first_name}
                  </p>
                  <p className="constructionName">
                    {item && item?.construction_name
                      ? item?.construction_name
                      : item?.construction
                        ? item?.construction?.name
                        : ""}
                  </p>
                  <p className="constructionName">{item && item?.comment}</p>
                </div>
                <div className="button">
                  <p className="subTitle">
                    <span className="amount">{item.from}~{item.to}</span>
                  </p>
                </div>
                {/* <div className="button">
                                    {item?.typeCollection === 1 ? (
                                        <div className="wrapperbtn">
                                            <span className="amount">-{item.quantity}</span>
                                            <span className="btn">
                                                <IconButton disableRipple={true}>
                                                    <img src={arrow_decrease} alt="icon" />
                                                </IconButton>
                                            </span>
                                        </div>
                                    ) : (
                                        <div className="wrapperbtn">
                                            <span className="amount">+{item.quantity}</span>
                                            <span className="btn">
                                                <IconButton disableRipple={true}>
                                                    <img src={arrow_increase} alt="icon" />
                                                </IconButton>
                                            </span>
                                        </div>
                                    )}
                                </div> */}
              </div>
            );
          })}
      </div>
    </StyledVehicleDetailHistory>
  );
};
